/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			this.parent = this.closest('.product-recommendations--parent');
		}
		reinitializeTrustpilot() {
			const loadWidgets = () => {
				if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') {
					return false;
				}
				this.querySelectorAll('.trustpilot-widget').forEach((widget) => {
					window.Trustpilot.loadFromElement(widget, true);
				});
				return true;
			};

			if (loadWidgets()) return;

			// Trustpilot bootstrap può arrivare dopo il fetch AJAX
			let attempts = 0;
			const maxAttempts = 20;
			const timer = setInterval(() => {
				attempts += 1;
				if (loadWidgets() || attempts >= maxAttempts) {
					clearInterval(timer);
				}
			}, 250);
		}
		fetchProducts() {
			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						if (typeof window.reinitializePdpLinkedProducts === 'function') {
							window.reinitializePdpLinkedProducts(this);
						}

						this.reinitializeTrustpilot();

						if (this.parent) {
							this.parent.classList.add('product-recommendations--full');

							if (document.body.classList.contains('open-cart')) {
								this.parent.classList.add('active');
							}
						}
					}

					this.classList.add('product-recommendations--loaded');
				})
				.catch((e) => {
					console.error(e);
				});
		}
		connectedCallback() {
			this.fetchProducts();
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}